import { motion } from "framer-motion";
import { imageUrl } from "@/api";

export const AdsSection = ({ ads }) => {
  if (!ads || ads.length === 0) return null;
  return (
    <section data-testid="ads-section" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <span className="text-xs sm:text-sm uppercase tracking-[0.28em] font-bold text-[var(--forest-2)]">Offers & Updates</span>
        </div>
        <div className={`grid gap-5 ${ads.length === 1 ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"}`}>
          {ads.map((ad, i) => {
            const img = (
              <img src={imageUrl(ad.image_url)} alt={ad.title || "Offer banner"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
            );
            return (
              <motion.div
                key={ad.id}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                data-testid={`ad-banner-${ad.id}`}
                className="relative overflow-hidden rounded-[2rem] border border-[var(--border)] ambient group aspect-[16/9]"
              >
                {ad.link ? (
                  <a href={ad.link} target="_blank" rel="noopener noreferrer" className="block w-full h-full">{img}</a>
                ) : img}
                {ad.title && (
                  <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-5">
                    <span className="text-white font-serif-display text-xl sm:text-2xl">{ad.title}</span>
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
